var _mask, _path, _rect, _rect2, _rect3, _ellipse;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_90_227",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 16H10C11.1046 16 12 15.1045 12 14V3.86107V2.66663C12 1.56206 11.1046 0.666626 10 0.666626H9H2C0.89543 0.666626 0 1.56206 0 2.66662V14C0 15.1045 0.895431 16 2 16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H2V17H10V15ZM1 14V2.66662H-1V14H1ZM2 1.66663H9V-0.333374H2V1.66663ZM9 1.66663H10V-0.333374H9V1.66663ZM11 2.66663V3.86107H13V2.66663H11ZM11 3.86107V14H13V3.86107H11ZM2 15C1.44772 15 1 14.5522 1 14H-1C-1 15.6568 0.343146 17 2 17V15ZM10 17C11.6569 17 13 15.6568 13 14H11C11 14.5522 10.5523 15 10 15V17ZM10 1.66663C10.5523 1.66663 11 2.11434 11 2.66663H13C13 1.00977 11.6569 -0.333374 10 -0.333374V1.66663ZM1 2.66662C1 2.11434 1.44771 1.66663 2 1.66663V-0.333374C0.343147 -0.333374 -1 1.00977 -1 2.66662H1Z",
    fill: "#D91F05",
    mask: "url(#path-1-inside-1_90_227)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.84216,
    y: 8.00012,
    width: 6.63158,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.84216,
    y: 5.00012,
    width: 6.63158,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.84216,
    y: 11.0001,
    width: 6.63158,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.31577,
    cy: 1,
    rx: 1.26316,
    ry: 1,
    fill: "#D91F05"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.df0c71f7.svg";
export { ForwardRef as ReactComponent };